// Musí být první import — modul při vyhodnocení nasazuje odposlech konzole
// a přebírá přístupový klíč z adresy do cookie. Co se zaloguje dřív, to už se
// do hlášení nedostane. Samotný widget se nasazuje až na konci souboru.
import { initFeedback, screenshotOptions } from 'xart-feedback-widget/nette'
import { createModernScreenshotCapture } from 'xart-feedback-widget/adapters/modernScreenshot'
import { initRecaptchaV3, initUtils } from "xart-utils";
import './_modalSizes'
initUtils({
    filePond: true,
    quill: false,
    froala: false,
    tomSelect: true
})
initRecaptchaV3()

import('./_formLoading').then(module => module.default())
import('../Components/Search/SearchListControl/SearchListControl').then(module => {module.default()})
import('../Components/Reclam/ReclamFormControl/ReclamFormControl').then(module => {module.default()})
import('../Components/Organization/OrganizationProfileDetailControl/OrganizationProfileDetailControl').then(module => {module.default()})
import('../Components/Organization/OrganizationDetailControl/OrganizationDetailControl').then(module => {module.default()})
import('./_footerCarousel').then(module => module.default())
import('../Components/Menu/HeaderControl/HeaderControl').then(module => {module.default()})
import('./_gallery').then(module => module.default())
import('./_consentArticleModal').then(module => module.default())
import('../../AdminModule/Components/Chat/ChatControl/ChatControl').then(module => {module.default()})


// Widget zpětné vazby. Vrátí null, když se nemá zobrazit (chybí adresa služby
// nebo uživatel nemá osobní klíč) — to je běžný stav, ne chyba.
// createModernScreenshotCapture: WebKit (iOS) nemá getDisplayMedia, snímek se
// tam vyrenderuje z DOM místo nabídky nahrát obrázek ze zařízení.
initFeedback({
    screenshot: screenshotOptions(createModernScreenshotCapture()),
    theme: { accent: '#0053A2' },
    launcher: { label: 'Zpětná vazba' },
})
